import { render } from "./EmpleadoArchivoTipoForm.vue?vue&type=template&id=ec9f13e6&scoped=true"
import script from "./EmpleadoArchivoTipoForm.vue?vue&type=script&lang=js"
export * from "./EmpleadoArchivoTipoForm.vue?vue&type=script&lang=js"

import "./EmpleadoArchivoTipoForm.vue?vue&type=style&index=0&id=ec9f13e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9f13e6"]])

export default __exports__